import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { calculateAgeFromDob, capitalizeFirstLetter, extractTime, extractTimeNew, formateDate, getDate, removeSpecialCharacter } from '../../../../utils/commonfunction';
import { getPrescription, medicalHistoryDocument } from '../../services/patient.services';
import { useTranslation } from "react-i18next";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "jspdf-autotable";
import ReactToPrint from 'react-to-print';
import { MEDICINE_OPTIONS, ROLE } from '../../../../utils/Constants';
import logoUrl from "../../../../assets/center/images/heal_logo.png"
import { isArray } from 'jquery';

export default function MedicalHistoryView({ userRole }) {
    console.log("userRole-->", userRole)
    const location = useLocation();
    const btnRef = useRef();
    const [historyData, setHistoryData] = useState({});
    const [prescriptionData, setPrescriptionData] = useState({});
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const targetRef = useRef();
    const locationInfo = location?.state?.info;
    const [documentData, setDocumentData] = useState([]);

    console.log("location-->", location?.state)
    console.log("locationInfo-->", locationInfo)

    const getPrescriptionDetail = (id) => {
        getPrescription({ history_id: id }, userRole)
            .then((response) => {
                setHistoryData(response?.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };


    const onDownload = (id) => {
        setLoading(true);
        getPrescription({ history_id: id }, userRole)
            .then((response) => {
                setPrescriptionData(response?.data);
                setTimeout(() => {
                    btnRef.current.click();
                    setLoading(false);
                }, 100)
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    }

    const formatValueWithUnit = (value, unit) => (value !== undefined ? `${value} ${unit}` : "-");

    const getMedicalHistoryDocument = (id) => {
        let formData = new FormData();
        formData.append("patient_id", id);
        medicalHistoryDocument(formData, userRole)
            .then((response) => {
                setDocumentData(response?.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    // const getFileName = (url) => {
    //     const fileName = url.split("/").pop();
    //     return fileName;
    // };

    const getFileName = (url) => {
        return typeof url === "string" ? url.split("/").pop() : "";
    };

    const today = new Date(new Date().toDateString());

    const latestUpcomingAppointment = location?.state?.medical_data
        ?.filter(item => new Date(item.appointment_date) >= today)
        ?.reduce((latest, current) => {
            const currentDate = new Date(current.appointment_date);
            const latestDate = new Date(latest?.appointment_date);
            return (!latest || currentDate > latestDate) ? current : latest;
        }, null);

    return (
        <main id="main-content" className="mt-4">
            <div className="ms-3 me-3">
                <div className="row">
                    {location?.state?.info && (
                        <div className="col-md-12">
                            <div className="card p-4 mb-4 card-info">
                                <h3>Personal Info</h3>
                                <p className="mb-1">#{location.state.info?.patient_register_id}</p>
                                <h4 className="mb-1">{capitalizeFirstLetter(location.state.info?.name)}</h4>
                                <div className="mb-3 d-flex gap-2 align-items-center">
                                    <p className="m-0">{capitalizeFirstLetter(location.state.info?.gender)}</p>
                                    {location.state.info?.gender && <p className="m-0">|</p>}
                                    {location.state.info?.dob && <p className="m-0">{calculateAgeFromDob(location.state.info?.dob)} years</p>}
                                    {location.state.info?.dob && <p className="m-0">|</p>}
                                    <p className="m-0">{location.state.info?.phone_number}</p>
                                </div>
                                <div className="table-div-info">
                                    <div className="table-div-info-row">
                                        <div className="table-div-info-item">
                                            <p className="m-0">Weight</p>
                                        </div>
                                        <div className="table-div-info-item">
                                            <p className="m-0">{locationInfo?.health_matrix?.weight ? formatValueWithUnit(locationInfo?.health_matrix?.weight, "Kg") : "-"}</p>
                                        </div>
                                    </div>
                                    <div className="table-div-info-row">
                                        <div className="table-div-info-item">
                                            <p className="m-0">Height</p>
                                        </div>
                                        <div className="table-div-info-item">
                                            <p className="m-0">{locationInfo?.health_matrix?.height ? formatValueWithUnit(locationInfo?.health_matrix?.height, "cm.") : "-"}</p>
                                        </div>
                                    </div>
                                    <div className="table-div-info-row">
                                        <div className="table-div-info-item">
                                            <p className="m-0">Blood Pressure</p>
                                        </div>
                                        <div className="table-div-info-item">
                                            <p className="m-0">{locationInfo?.health_matrix?.blood_pressure ? formatValueWithUnit(locationInfo?.health_matrix?.blood_pressure, "mm/hg") : "-"}</p>
                                        </div>
                                    </div>
                                    <div className="table-div-info-row">
                                        <div className="table-div-info-item">
                                            <p className="m-0">Sleep Pattern</p>
                                        </div>
                                        <div className="table-div-info-item">
                                            <p className="m-0">
                                                {locationInfo?.health_matrix?.sleep_pattern
                                                    ? removeSpecialCharacter(capitalizeFirstLetter(locationInfo?.health_matrix?.sleep_pattern))
                                                    : "-"}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="table-div-info-row">
                                        <div className="table-div-info-item">
                                            <p className="m-0">Fasting Level Sugar</p>
                                        </div>
                                        <div className="table-div-info-item">
                                            <p className="m-0">{locationInfo?.health_matrix?.fasting_sugar_level ? formatValueWithUnit(locationInfo?.health_matrix?.fasting_sugar_level, "mg/dl") : "-"}</p>
                                        </div>
                                    </div>
                                    <div className="table-div-info-row">
                                        <div className="table-div-info-item">
                                            <p className="m-0">Postprandial Sugar</p>
                                        </div>
                                        <div className="table-div-info-item">
                                            <p className="m-0">{locationInfo?.health_matrix?.postprandial_sugar ? formatValueWithUnit(locationInfo?.health_matrix?.postprandial_sugar, "mg/dl") : "-"}</p>
                                        </div>
                                    </div>
                                    <div className="table-div-info-row">
                                        <div className="table-div-info-item">
                                            <p className="m-0">HbA1c Sugar</p>
                                        </div>
                                        <div className="table-div-info-item">
                                            <p className="m-0">{locationInfo?.health_matrix?.hba1c_sugar ? formatValueWithUnit(locationInfo?.health_matrix?.hba1c_sugar, "%") : "-"}</p>
                                        </div>
                                    </div>
                                    {/* <div className='table-div-info-row'>
                                        <div className='table-div-info-item'><p className='m-0'>Sugar Type</p></div>
                                        <div className='table-div-info-item'>
                                            <p className='m-0'>
                                                {locationInfo?.health_matrix?.sugar_type !== undefined
                                                    ? removeSpecialCharacter(capitalizeFirstLetter(locationInfo?.health_matrix?.sugar_type))
                                                    : "-"}
                                            </p>
                                        </div>
                                    </div> */}
                                    <div className="table-div-info-row">
                                        <div className="table-div-info-item">
                                            <p className="m-0">Pulse Rate</p>
                                        </div>
                                        <div className="table-div-info-item">
                                            <p className="m-0">{locationInfo?.health_matrix?.pulse_rate ? formatValueWithUnit(locationInfo?.health_matrix?.pulse_rate, "BPM") : "-" }</p>
                                        </div>
                                    </div>
                                    <div className="table-div-info-row">
                                        <div className="table-div-info-item">
                                            <p className="m-0">SPO2</p>
                                        </div>
                                        <div className="table-div-info-item">
                                            <p className="m-0">{locationInfo?.health_matrix?.spo2 ? formatValueWithUnit(locationInfo?.health_matrix?.spo2, "%") : "-"}</p>
                                        </div>
                                    </div>
                                    <div className="table-div-info-row">
                                        <div className="table-div-info-item">
                                            <p className="m-0">Temperature</p>
                                        </div>
                                        <div className="table-div-info-item">
                                            <p className="m-0">{locationInfo?.health_matrix?.temperature ? formatValueWithUnit(locationInfo?.health_matrix?.temperature, "°F") : "-"}</p>
                                        </div>
                                    </div>
                                    <div className="table-div-info-row">
                                        <div className="table-div-info-item">
                                            <p className="m-0">Digestion</p>
                                        </div>
                                        <div className="table-div-info-item">
                                            <p className="m-0">{locationInfo?.health_matrix?.digestion || "-"}</p>
                                        </div>
                                    </div>
                                    <div className="table-div-info-row">
                                        <div className="table-div-info-item">
                                            <p className="m-0">Urine Frequency</p>
                                        </div>
                                        <div className="table-div-info-item">
                                            <p className="m-0">{locationInfo?.health_matrix?.urine_frequency || "-"}</p>
                                        </div>
                                    </div>
                                    {/* { console.log("****",location.state.info?._id)} */}
                                    <div className="card-info-action">
                                        <button
                                            className="btn btn-primary mt-2"
                                            onClick={() => {
                                                getMedicalHistoryDocument(locationInfo?._id);
                                            }}
                                            data-bs-toggle="offcanvas"
                                            data-bs-target="#view-medical-document"
                                        >
                                            View Medical History Document
                                        </button>
                                        <button
                                            className="btn btn-secondary mt-2 ms-2"
                                            onClick={() => {
                                                navigate(`/${userRole}/patient/appointment/view/${locationInfo?._id}`);
                                            }}
                                        >
                                            Back
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {location?.state?.medical_data?.length > 0 &&
                        location?.state?.medical_data?.map((item, index) => (
                            <div className="col-md-12" key={index} id={`pdf-content-${item._id}`}>
                                <div className="card p-4 mb-4 card-info">
                                    {/* <h3>Consultations</h3> */}
                                    {item._id === latestUpcomingAppointment?._id ? <h3>Current Consultation</h3> : <h3>Past Consultation</h3>}
                                    <p className="mb-1">#{item?.appointment_register_id}</p>
                                    <h4 className="mb-1">{capitalizeFirstLetter(item?.doctor_name)}</h4>
                                    <div className="mb-3 d-flex gap-2 align-items-center">
                                        <p className="m-0">{formateDate(item?.appointment_date)}</p> | <p className="m-0">{extractTime(item?.appointment_date)}</p>
                                    </div>
                                    <div className="table-div-info">
                                        {item?.diagnosis_notes?.trim() && (
                                        <div className="table-div-info-row">
                                            <div className="table-div-info-item">
                                            <p className="m-0">Diagnosis</p>
                                            </div>
                                            <div className="table-div-info-item">
                                            <p className="m-0">{capitalizeFirstLetter(item.diagnosis_notes)}</p>
                                            </div>
                                        </div>
                                        )}

                                        {Array.isArray(item?.symptoms) && item.symptoms.length > 0 && (
                                        <div className="table-div-info-row">
                                            <div className="table-div-info-item">
                                            <p className="m-0">Chief Complaint</p>
                                            </div>
                                            <div className="table-div-info-item">
                                            <p className="m-0">
                                                {item.symptoms.map((symptom) => capitalizeFirstLetter(symptom.name)).join(", ")}
                                            </p>
                                            </div>
                                        </div>
                                        )}

                                        <div className="d-flex gap-2 mt-3">
                                            <button
                                                className="btn btn-primary"
                                                type="button"
                                                onClick={() => {
                                                    getPrescriptionDetail(item?._id);
                                                }}
                                                data-bs-toggle="offcanvas"
                                                data-bs-target="#view-staff"
                                            >
                                                View
                                            </button>
                                            <button className="btn btn-secondary" type="button" onClick={() => onDownload(item?._id)}>
                                                Download
                                            </button>
                                            <div className="d-none">
                                                <ReactToPrint
                                                    // onBeforePrint={() => {}}
                                                    trigger={() => (
                                                        <button className="btn btn-secondary" type="button" ref={btnRef}>
                                                            Download
                                                        </button>
                                                    )}
                                                    content={() => targetRef.current}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
            {/* VIEW MEDICAL HISTORY */}
            <div className="offcanvas offcanvas-end right-modal-w" id="view-staff" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-modal="true" role="dialog">
                <div className="offcanvas-header">
                    <h3 className="offcanvas-title" id="offcanvasRightLabel">
                        View History
                    </h3>
                    <button type="button" className="btn btn-icon ms-auto" data-bs-dismiss="offcanvas" aria-label="Close">
                        <i className="ti ti-x"></i>
                    </button>
                </div>
                <div className="offcanvas-body">
                    <div className="view-staff-info">
                        <div className="row gap-4">
                            <div className="col-md-12">
                                <h4>{t("Doctor Name")}</h4>
                                <p>{capitalizeFirstLetter(historyData?.doctor_name)}</p>
                            </div>
                            {historyData.diagnosis_notes?.trim() && (
                            <div className="col-md-12">
                                <h4>{t("Diagnosis")}</h4>
                                <p>{capitalizeFirstLetter(historyData.diagnosis_notes)}</p>
                            </div>
                            )}

                            {Array.isArray(historyData.symptoms) && historyData.symptoms.length > 0 && (
                            <div className="col-md-12">
                                <h4>{t("Chief Complaint")}</h4>
                                <p>
                                {historyData.symptoms
                                    .map((symptom) => capitalizeFirstLetter(symptom.name))
                                    .join(", ")}
                                </p>
                            </div>
                            )}

                            {historyData.past_medical_history ? (
                                <div className="col-md-12">
                                    <h4>{t("Past Medical History")}</h4>
                                    <p>{capitalizeFirstLetter(historyData.past_medical_history)}</p>
                                </div>
                            ) : null}
                            {/* {historyData.investigation_advise ?
                                <div className="col-md-12">
                                    <h4>{t("Investigation Advise")}</h4>
                                    <p>{capitalizeFirstLetter(historyData.investigation_advise)}</p>
                                </div> : null} */}
                            <div className="col-md-12">
                                <h4>{t("Appointment Date")}</h4>
                                <p>{historyData.appointment_date ? formateDate(historyData.appointment_date) : "-"}</p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Appointment Time")}</h4>
                                <p>{historyData.appointment_date ? extractTime(historyData.appointment_date) : "-"}</p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Follow-up Date")}</h4>
                                <p>
                                    {
                                        historyData.follow_up_date
                                        ? formateDate(historyData.follow_up_date)
                                        : "N/A"
                                    }
                                </p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Diagnosis Test")}</h4>
                                <p>{capitalizeFirstLetter(historyData.test_name)}</p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Medicine Note")}</h4>
                                <p>{capitalizeFirstLetter(historyData.medicine_note)}</p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Medicines")}</h4>
                                {historyData?.medicines?.length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead className="bg-light">
                                                <tr>
                                                    <th className="py-2">{t("Medicine Name")}</th>
                                                    <th className="py-2 text-center">{t("Dosage")}</th>
                                                    {/* <th className="py-2 text-center">{t("Frequency")}</th> */}
                                                    <th className="py-2 text-center">{t("Start Date")}</th>
                                                    <th className="py-2 text-center">{t("End Date")}</th>
                                                    <th className="py-2 text-center">{t("Dosage(Times)")}</th>
                                                    <th className="py-2 text-center">{t("Instructions")}</th>
                                                    <th className="py-2 text-center">{t("Remarks")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {historyData?.medicines?.map((medicine) => (
                                                    <>
                                                        <tr key={medicine.medicine.name}>
                                                            {/* <td className="py-2">{capitalizeFirstLetter(medicine.medicine_id ? medicine.medicine.name : medicine.medicine_name)}</td> */}
                                                            <td className="py-2">{capitalizeFirstLetter(medicine.medicine.name)}</td>
                                                            <td className="py-2 text-center">{medicine?.dosage}</td>
                                                            {/* <td className="py-2 text-center">{medicine?.frequency}</td> */}
                                                            <td className="py-2 text-center">{formateDate(medicine?.start_date)}</td>
                                                            <td className="py-2 text-center">{formateDate(medicine?.end_date)}</td>
                                                            <td className="py-2 text-center">{medicine.notification_times?.length > 0 ? medicine.notification_times.join(", ") : "-"}</td>
                                                            <td className="py-2 text-center">{medicine?.meal_time ? MEDICINE_OPTIONS?.find((option) => medicine?.meal_time === option.value)?.label : "-"}</td>
                                                            <td className="py-2 text-center">{medicine?.remarks ? capitalizeFirstLetter(medicine?.remarks) : "-"}</td>
                                                        </tr>
                                                        {/* <tr>
                                                            <td colSpan="6" className="py-2">
                                                                <span style={{ fontWeight: "bold", marginRight: "5px" }}>Note : </span>{capitalizeFirstLetter(medicine?.medicine_note)}
                                                            </td>
                                                        </tr> */}
                                                    </>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* PRESCRIPTION TEMPLATE */}
            {console.log("prescriptionData-->", prescriptionData)}
            {console.log("locationInfo-->", locationInfo)}
            <div className="d-none">
                <div ref={targetRef}>
                    <div
                        style={{
                            maxWidth: "800px",
                            margin: "20px auto",
                            padding: "24px",
                            backgroundColor: "#fff",
                            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                            color: "#2B2B4E",
                            boxShadow: "0 0 6px rgba(0,0,0,0.08)",
                            borderRadius: "6px",
                        }}
                    >
                        {/* Header */}
                        <div style={{ borderBottom: "2px solid #FEC951", paddingBottom: "8px", marginBottom: "16px" }}>
                            <table style={{ width: "100%", fontSize: "13px" }}>
                                <tbody>
                                    <tr>
                                        <td style={{ verticalAlign: "middle", width: "50%" }}>
                                            <img src={logoUrl} alt="Logo" style={{ height: "80px" }} />
                                        </td>
                                        <td style={{ textAlign: "right", verticalAlign: "middle" }}>
                                            <p style={{ fontWeight: "bold", margin: "0", fontSize: "14px" }}>#{prescriptionData?.center_register_id}</p>
                                            <p style={{ fontWeight: "bold", margin: "0", fontSize: "13px" }}>{capitalizeFirstLetter(prescriptionData?.center_name)}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* Appointment Info */}
                        <table style={{ width: "100%", marginBottom: "12px", fontSize: "13px" }}>
                            <tbody>
                            <tr>
                                <td style={{ padding: "4px 0", width: "50%" }}>
                                <strong style={{ color: "#6E6ED3" }}>Appointment ID:</strong><br />
                                {prescriptionData?.appointment_register_id || "-"}
                                </td>
                                <td style={{ padding: "4px 0", textAlign: "right" }}>
                                <strong style={{ color: "#6E6ED3" }}>Date:</strong><br />
                                {getDate(prescriptionData?.appointment_date) || "-"}
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        {/* Divider */}
                        <div style={{ height: "6px", width: "100%", background: "linear-gradient(to right, #FEC951 50%, #FD7D31 50%)", margin: "20px 0" }} />

                         {/* Patient Information */}
                        <div style={{ marginBottom: "20px" }}>
                            {/* <h2 style={{ fontSize: "16px", fontWeight: "700", marginBottom: "12px", color: "#2B2B4E" }}>
                            Patient Information
                            </h2> */}
                            <table style={{ width: "100%", fontSize: "13px", borderCollapse: "separate", borderSpacing: "0 8px" }}>
                            <tbody>
                                {/* Row 1 */}
                                <tr>
                                <td>
                                    <div style={{ marginBottom: "2px", color: "#6E6ED3", fontWeight: "600" }}>Name</div>
                                    <div style={{ fontWeight: "500", color: "#333" }}>
                                    {capitalizeFirstLetter(locationInfo?.name) || "-"}
                                    </div>
                                </td>
                                <td>
                                    <div style={{ marginBottom: "2px", color: "#6E6ED3", fontWeight: "600" }}>Phone Number</div>
                                    <div style={{ fontWeight: "500", color: "#333" }}>
                                    {locationInfo?.phone_number || "-"}
                                    </div>
                                </td>
                                <td>
                                    <div style={{ marginBottom: "2px", color: "#6E6ED3", fontWeight: "600" }}>Age</div>
                                    <div style={{ fontWeight: "500", color: "#333" }}>
                                    {locationInfo?.dob ? calculateAgeFromDob(locationInfo?.dob) + " years" : "-"}
                                    </div>
                                </td>
                                <td>
                                    <div style={{ marginBottom: "2px", color: "#6E6ED3", fontWeight: "600" }}>Gender</div>
                                    <div style={{ fontWeight: "500", color: "#333" }}>
                                    {capitalizeFirstLetter(locationInfo?.gender) || "-"}
                                    </div>
                                </td>
                                </tr>

                                {/* Row 2 */}
                                <tr>
                                <td>
                                    <div style={{ marginBottom: "2px", color: "#6E6ED3", fontWeight: "600" }}>Weight</div>
                                    <div style={{ fontWeight: "500", color: "#333" }}>
                                    {locationInfo?.health_matrix?.weight
                                        ? locationInfo?.health_matrix?.weight + " kg"
                                        : "-"}
                                    </div>
                                </td>
                                <td>
                                    <div style={{ marginBottom: "2px", color: "#6E6ED3", fontWeight: "600" }}>Height</div>
                                    <div style={{ fontWeight: "500", color: "#333" }}>
                                    {locationInfo?.health_matrix?.height
                                        ? locationInfo?.health_matrix?.height + " cm"
                                        : "-"}
                                    </div>
                                </td>
                                <td>
                                    <div style={{ marginBottom: "2px", color: "#6E6ED3", fontWeight: "600" }}>Blood Pressure</div>
                                    <div style={{ fontWeight: "500", color: "#333" }}>
                                    {locationInfo?.health_matrix?.blood_pressure
                                        ? locationInfo?.health_matrix?.blood_pressure + " mmHg"
                                        : "-"}
                                    </div>
                                </td>
                                <td>
                                    <div style={{ marginBottom: "2px", color: "#6E6ED3", fontWeight: "600" }}>Pulse Rate</div>
                                    <div style={{ fontWeight: "500", color: "#333" }}>
                                    {locationInfo?.health_matrix?.pulse_rate
                                        ? locationInfo?.health_matrix?.pulse_rate + " bpm"
                                        : "-"}
                                    </div>
                                </td>
                                </tr>

                                {/* Row 3 */}
                                <tr>
                                <td>
                                    <div style={{ marginBottom: "2px", color: "#6E6ED3", fontWeight: "600" }}>SPO2</div>
                                    <div style={{ fontWeight: "500", color: "#333" }}>
                                    {locationInfo?.health_matrix?.spo2 ? locationInfo?.health_matrix?.spo2 + " %" : "-"}
                                    </div>
                                </td>
                                <td>
                                    <div style={{ marginBottom: "2px", color: "#6E6ED3", fontWeight: "600" }}>Temperature</div>
                                    <div style={{ fontWeight: "500", color: "#333" }}>
                                    {locationInfo?.health_matrix?.temperature
                                        ? locationInfo?.health_matrix?.temperature + " °F"
                                        : "-"}
                                    </div>
                                </td>
                                <td>
                                    <div style={{ marginBottom: "2px", color: "#6E6ED3", fontWeight: "600" }}>Follow Up Date</div>
                                    <div style={{ fontWeight: "500", color: "#333" }}>
                                    {formateDate(prescriptionData?.follow_up_date) || "-"}
                                    </div>
                                </td>
                                <td></td>
                                </tr>

                                {/* Address Row */}
                                {locationInfo?.address && (
                                <tr>
                                    <td colSpan={4}>
                                    <div style={{ marginBottom: "2px", color: "#6E6ED3", fontWeight: "600" }}>Address</div>
                                    <div style={{ fontWeight: "500", color: "#333" }}>
                                        {capitalizeFirstLetter(locationInfo?.address) || "-"}
                                    </div>
                                    </td>
                                </tr>
                                )}

                                {/* Laboratory Test Row */}
                                {prescriptionData?.test_name && (
                                <tr>
                                    <td colSpan={4}>
                                    <div style={{ marginBottom: "2px", color: "#6E6ED3", fontWeight: "600" }}>Laboratory Test</div>
                                    <div style={{ fontWeight: "500", color: "#333" }}>
                                        {capitalizeFirstLetter(prescriptionData?.test_name) || "-"}
                                    </div>
                                    </td>
                                </tr>
                                )}
                            </tbody>
                            </table>
                        </div>

                        {/* Medicines List */}
                        <h2 style={{ fontSize: "18px", fontWeight: "700", marginBottom: "12px" }}>Prescribed Medicines</h2>
                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px", marginBottom: "20px" }}>
                            <thead>
                                <tr style={{ backgroundColor: "#F2F3FE" }}>
                                    {["Name", "Dosage", "End Date", "Times", "Instructions", "Remarks"].map((header, i) => (
                                        <th key={i} style={{ border: "1px solid #ccc", padding: "10px", textAlign: "left", color: "#3A2538" }}>
                                            {header}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {prescriptionData?.medicines?.length > 0 ? (
                                    prescriptionData.medicines?.map((med, idx) => (
                                        <tr key={idx} style={{ backgroundColor: "#FCFCFF" }}>
                                            <td style={{ border: "1px solid #ccc", padding: "10px" }}>{capitalizeFirstLetter(med.medicine_id ? med.medicine.name : med.medicine_name)}</td>
                                            <td style={{ border: "1px solid #ccc", padding: "10px" }}>{med.dosage || "-"}</td>
                                            <td style={{ border: "1px solid #ccc", padding: "10px" }}>{formateDate(med.end_date) || "-"}</td>
                                            <td style={{ border: "1px solid #ccc", padding: "10px" }}>{med.notification_times?.length ? med.notification_times.join(", ") : "-"}</td>
                                            <td style={{ border: "1px solid #ccc", padding: "10px" }}>{MEDICINE_OPTIONS.find((option) => option.value === med.meal_time)?.label || "-"}</td>
                                            <td style={{ border: "1px solid #ccc", padding: "10px" }}>{capitalizeFirstLetter(med?.remarks) || "-"}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={6} style={{ padding: "12px", textAlign: "center" }}>
                                            No medicines prescribed.
                                        </td>
                                    </tr>
                                )}
                                {prescriptionData?.medicine_note && (
                                    <tr>
                                        <td colSpan={6} style={{ padding: "12px", fontStyle: "italic", color: "#545D73" }}>
                                            <strong>Note:</strong> {capitalizeFirstLetter(prescriptionData.medicine_note)}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {/* Doctor Info */}
                        <h2 style={{ fontSize: "18px", fontWeight: "700", marginBottom: "12px" }}>Physician Information</h2>
                        <table style={{ width: "100%", fontSize: "14px" }}>
                            <tbody>
                                <tr>
                                    <td style={{ padding: "8px" }}>
                                        <strong style={{ color: "#6E6ED3" }}>Name:</strong>
                                        <br />
                                        {prescriptionData?.doctor_name || "-"}
                                    </td>
                                    <td style={{ padding: "8px" }}>
                                        <strong style={{ color: "#6E6ED3" }}>Phone:</strong>
                                        <br />
                                        {prescriptionData?.doctor_phone_number || "-"}
                                    </td>

                                    {prescriptionData?.doctor_email && (
                                        <td style={{ padding: "8px" }}>
                                            <strong style={{ color: "#6E6ED3" }}>Email:</strong>
                                            <br />
                                            {prescriptionData.doctor_email}
                                        </td>
                                    )}
                                </tr>
                            </tbody>
                        </table>

                        {/* Footer */}
                        <div style={{ borderTop: "2px solid #FD7D31", marginTop: "30px", paddingTop: "12px", fontSize: "12px", textAlign: "center", color: "#999", fontStyle: "italic" }}>
                            This prescription is electronically generated and valid without signature.
                        </div>
                    </div>
                </div>
            </div>
            {/* PRESCRIPTION TEMPLATE */}
            {/* <div className="d-none">
                <div ref={targetRef}>
                    <div
                        style={{
                            maxWidth: "800px",
                            margin: "50px auto",
                            padding: "40px",
                            backgroundColor: "#fff",
                            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                            color: "#2B2B4E",
                            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                            borderRadius: "8px",
                        }}
                    >
                        <div style={{ borderBottom: "3px solid #FEC951", paddingBottom: "12px", marginBottom: "24px" }}>
                            <div style={{ marginBottom: "15px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <h1 style={{ fontSize: "32px", fontWeight: "700", margin: 0, textAlign: "center" }}>PRESCRIPTION</h1>
                            </div>

                            <table style={{ width: "100%", fontSize: "14px", borderCollapse: "separate", borderSpacing: "0 12px" }}>
                                <tbody>
                                    <tr>
                                        <td style={{ verticalAlign: "center" }}>
                                            <img src={logoUrl} alt="Logo" style={{ height: "100px" }} />
                                        </td>

                                        <td style={{ verticalAlign: "center", textAlign: "right" }}>
                                            <p style={{ fontWeight: "bold", margin: "0" }}>#{prescriptionData?.center_register_id}</p>
                                            <p style={{ fontWeight: "bold", margin: "0" }}>{capitalizeFirstLetter(prescriptionData?.center_name)}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <table style={{ width: "100%", marginBottom: "20px", fontSize: "14px" }}>
                            <tbody>
                                <tr>
                                    <td style={{ padding: "10px 0", width: "50%" }}>
                                        <strong style={{ color: "#6E6ED3" }}>Appointment ID:</strong>
                                        <br />
                                        {prescriptionData?.appointment_register_id || "-"}
                                    </td>
                                    <td style={{ padding: "10px 0", textAlign: "right" }}>
                                        <strong style={{ color: "#6E6ED3" }}>Prescription Date:</strong>
                                        <br />
                                        {getDate(prescriptionData?.createdAt) || "-"}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div style={{ height: "6px", width: "100%", background: "linear-gradient(to right, #FEC951 50%, #FD7D31 50%)", margin: "20px 0" }} />

                        <div style={{ marginBottom: "30px" }}>
                            <h2 style={{ fontSize: "18px", fontWeight: "700", marginBottom: "16px", color: "#2B2B4E" }}>Patient Information</h2>
                            <table style={{ width: "100%", fontSize: "14px", borderCollapse: "separate", borderSpacing: "0 12px" }}>
                                <tbody>
                                    <tr>
                                        <td style={{ verticalAlign: "top" }}>
                                            <div style={{ marginBottom: "4px", color: "#6E6ED3", fontWeight: "600" }}>Name</div>
                                            <div style={{ fontWeight: "500", color: "#333" }}>{capitalizeFirstLetter(locationInfo?.name) || "-"}</div>
                                        </td>
                                        <td style={{ verticalAlign: "top" }}>
                                            <div style={{ marginBottom: "4px", color: "#6E6ED3", fontWeight: "600" }}>Phone Number</div>
                                            <div style={{ fontWeight: "500", color: "#333" }}>{locationInfo?.phone_number || "-"}</div>
                                        </td>
                                        <td style={{ verticalAlign: "top" }}>
                                            <div style={{ marginBottom: "4px", color: "#6E6ED3", fontWeight: "600" }}>Age</div>
                                            <div style={{ fontWeight: "500", color: "#333" }}>{calculateAgeFromDob(locationInfo?.dob) || "-"}</div>
                                        </td>
                                        <td style={{ verticalAlign: "top" }}>
                                            <div style={{ marginBottom: "4px", color: "#6E6ED3", fontWeight: "600" }}>Gender</div>
                                            <div style={{ fontWeight: "500", color: "#333" }}>{capitalizeFirstLetter(locationInfo?.gender) || "-"}</div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ verticalAlign: "top" }}>
                                            <div style={{ marginBottom: "4px", color: "#6E6ED3", fontWeight: "600" }}>Weight</div>
                                            <div style={{ fontWeight: "500", color: "#333" }}>{locationInfo?.health_matrix?.weight ? capitalizeFirstLetter(locationInfo?.health_matrix?.weight) + " kg" : "-"}</div>
                                        </td>
                                        <td style={{ verticalAlign: "top" }}>
                                            <div style={{ marginBottom: "4px", color: "#6E6ED3", fontWeight: "600" }}>Height</div>
                                            <div style={{ fontWeight: "500", color: "#333" }}>{locationInfo?.health_matrix?.height ? capitalizeFirstLetter(locationInfo?.health_matrix?.height) + " cm" : "-"}</div>
                                        </td>
                                        <td style={{ verticalAlign: "top" }}>
                                            <div style={{ marginBottom: "4px", color: "#6E6ED3", fontWeight: "600" }}>Blood Pressure</div>
                                            <div style={{ fontWeight: "500", color: "#333" }}>
                                                {locationInfo?.health_matrix?.blood_pressure ? capitalizeFirstLetter(locationInfo?.health_matrix?.blood_pressure) + " mmHg" : "-"}
                                            </div>
                                        </td>
                                        <td style={{ verticalAlign: "top" }}>
                                            <div style={{ marginBottom: "4px", color: "#6E6ED3", fontWeight: "600" }}>SPO2</div>
                                            <div style={{ fontWeight: "500", color: "#333" }}>
                                                {locationInfo?.health_matrix?.spo2 ? capitalizeFirstLetter(locationInfo?.health_matrix?.spo2) + " %" : "-"}
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ verticalAlign: "top" }}>
                                            <div style={{ marginBottom: "4px", color: "#6E6ED3", fontWeight: "600" }}>Temperature</div>
                                            <div style={{ fontWeight: "500", color: "#333" }}>{locationInfo?.health_matrix?.temperature ? capitalizeFirstLetter(locationInfo?.health_matrix?.temperature) + " °F" : "-"}</div>
                                        </td>
                                        <td style={{ verticalAlign: "top" }}>
                                            <div style={{ marginBottom: "4px", color: "#6E6ED3", fontWeight: "600" }}>Pulse Rate</div>
                                            <div style={{ fontWeight: "500", color: "#333" }}>{locationInfo?.health_matrix?.pulse_rate ? capitalizeFirstLetter(locationInfo?.health_matrix?.pulse_rate) + " bpm" : "-"}</div>
                                        </td>
                                        <td style={{ verticalAlign: "top" }}>
                                            <div style={{ marginBottom: "4px", color: "#6E6ED3", fontWeight: "600" }}>Follow Up Date</div>
                                            <div style={{ fontWeight: "500", color: "#333" }}>{formateDate(prescriptionData?.follow_up_date) || "-"}</div>
                                        </td>
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <td colSpan={4} style={{ verticalAlign: "top" }}>
                                            <div style={{ marginBottom: "4px", color: "#6E6ED3", fontWeight: "600" }}>Address</div>
                                            <div style={{ fontWeight: "500", color: "#333" }}>{capitalizeFirstLetter(locationInfo?.address) || "-"}</div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td colSpan={4} style={{ verticalAlign: "top" }}>
                                            <div style={{ marginBottom: "4px", color: "#6E6ED3", fontWeight: "600" }}>Laboratory Test</div>
                                            <div style={{ fontWeight: "500", color: "#333" }}>{capitalizeFirstLetter(prescriptionData?.test_name) || "-"}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <h2 style={{ fontSize: "18px", fontWeight: "700", marginBottom: "12px" }}>Prescribed Medicines</h2>
                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px", marginBottom: "20px" }}>
                            <thead>
                                <tr style={{ backgroundColor: "#F2F3FE" }}>
                                    {["Name", "Dosage", "Start", "End", "Times"].map((header, i) => (
                                        <th key={i} style={{ border: "1px solid #ccc", padding: "10px", textAlign: "left", color: "#3A2538" }}>
                                            {header}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {prescriptionData?.medicines?.length > 0 ? (
                                    prescriptionData.medicines.map((med, idx) => (
                                        <tr key={idx} style={{ backgroundColor: "#FCFCFF" }}>
                                            <td style={{ border: "1px solid #ccc", padding: "10px" }}>{capitalizeFirstLetter(med.medicine_id ? med.medicine.name : med.medicine_name)}</td>
                                            <td style={{ border: "1px solid #ccc", padding: "10px" }}>{med.dosage || "-"}</td>
                                            <td style={{ border: "1px solid #ccc", padding: "10px" }}>{formateDate(med.start_date) || "-"}</td>
                                            <td style={{ border: "1px solid #ccc", padding: "10px" }}>{formateDate(med.end_date) || "-"}</td>
                                            <td style={{ border: "1px solid #ccc", padding: "10px" }}>{med.notification_times?.length ? med.notification_times.join(", ") : "-"}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={6} style={{ padding: "12px", textAlign: "center" }}>
                                            No medicines prescribed.
                                        </td>
                                    </tr>
                                )}
                                {prescriptionData?.medicine_note && (
                                    <tr>
                                        <td colSpan={6} style={{ padding: "12px", fontStyle: "italic", color: "#545D73" }}>
                                            <strong>Note:</strong> {capitalizeFirstLetter(prescriptionData.medicine_note)}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        <h2 style={{ fontSize: "18px", fontWeight: "700", marginBottom: "12px" }}>Physician Information</h2>
                        <table style={{ width: "100%", fontSize: "14px" }}>
                            <tbody>
                                <tr>
                                    <td style={{ padding: "8px" }}>
                                        <strong style={{ color: "#6E6ED3" }}>Name:</strong>
                                        <br />
                                        {prescriptionData?.doctor_name || "-"}
                                    </td>
                                    <td style={{ padding: "8px" }}>
                                        <strong style={{ color: "#6E6ED3" }}>Phone:</strong>
                                        <br />
                                        {prescriptionData?.doctor_phone_number || "-"}
                                    </td>

                                    {prescriptionData?.doctor_email && (
                                        <td style={{ padding: "8px" }}>
                                            <strong style={{ color: "#6E6ED3" }}>Email:</strong>
                                            <br />
                                            {prescriptionData.doctor_email}
                                        </td>
                                    )}
                                </tr>
                            </tbody>
                        </table>

                        <div style={{ borderTop: "2px solid #FD7D31", marginTop: "30px", paddingTop: "12px", fontSize: "12px", textAlign: "center", color: "#999", fontStyle: "italic" }}>
                            Not for medico legal purposes.
                        </div>
                    </div>
                </div>
            </div> */}

            {/* MEDICAL HISTORY DOCUMENT */}
            <div
                className="offcanvas offcanvas-end"
                id="view-medical-document"
                data-bs-backdrop="static"
                tabIndex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-modal="true"
                role="dialog"
                style={{
                    width: "60vw",
                    maxHeight: "90vh",
                    overflowY: "auto",
                    position: "fixed",
                    bottom: "0",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: "1050",
                    top: "50px",
                }}
            >
                <div className="offcanvas-header">
                    <h3 className="offcanvas-title" id="offcanvasRightLabel">
                        View Medical History Document
                    </h3>
                    <button type="button" className="btn btn-icon ms-auto" data-bs-dismiss="offcanvas" aria-label="Close">
                        <i className="ti ti-x"></i>
                    </button>
                </div>
                <div className="offcanvas-body">
                    <div className="table-responsive">
                        <table className="table">
                            <thead className="table-light">
                                <tr>
                                    <th>{t("Doctor ID")}</th>
                                    <th>{t("Doctor Name")}</th>
                                    <th>{t("Doctor Email")}</th>
                                    <th>{t("Medical History Note")}</th>
                                    <th>Medical History Document</th>
                                </tr>
                            </thead>
                            <tbody>
                                {documentData && documentData.length > 0 ? (
                                    documentData?.map((doc, index) => (
                                        <tr key={index}>
                                            <td>#{doc.doctor_register_id}</td>
                                            <td>{capitalizeFirstLetter(doc.doctor_name)}</td>
                                            <td>{doc.doctor_email}</td>
                                            <td>{capitalizeFirstLetter(doc.medical_history_note)}</td>
                                            {/* <td>
                                                {doc.medical_history_document ? (
                                                    <a
                                                        href={doc.medical_history_document}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ textDecoration: 'none' }}
                                                    >
                                                        {getFileName(doc.medical_history_document)}
                                                    </a>
                                                ) : (
                                                    null
                                                )}
                                            </td> */}
                                            <td>
                                                {Array.isArray(doc.medical_history_document) ? (
                                                    doc.medical_history_document?.map((url, index) => (
                                                        <div key={index}>
                                                            <a href={url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                                                                {getFileName(url)}
                                                            </a>
                                                        </div>
                                                    ))
                                                ) : doc.medical_history_document ? (
                                                    <a href={doc.medical_history_document} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                                                        {getFileName(doc.medical_history_document)}
                                                    </a>
                                                ) : null}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: "center" }}>
                                            No Data Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </main>
    );
}
